module.exports = __webpack_public_path__ + "static/media/RegenerationStationUpcyclingstoreAshevilleNCsign2010Acryliconpanel.7457b8d4.webp";